module.exports = __webpack_public_path__ + "static/img/b14.79042ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b14.jpg
// module id = OBKn
// module chunks = 1